/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FavoriteItems = {
    type: 'array',
    contains: {
        type: 'FavoriteItem',
    },
};